import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './LogoList.module.postcss';

const DEFAULT_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/AmazonLogo-300x200.webp', alt: 'Amazon' },
  { src: 'https://static.seattlefoodtruck.com/logos/Bungie-300x200.webp', alt: 'Bungie' },
  { src: 'https://static.seattlefoodtruck.com/logos/comcastlogo-300x200.webp', alt: 'Comcast' },
  { src: 'https://static.seattlefoodtruck.com/logos/Expedia-300x200.webp', alt: 'Expedia' },
  { src: 'https://static.seattlefoodtruck.com/logos/googlelogo-300x200.webp', alt: 'Google' },
  { src: 'https://static.seattlefoodtruck.com/logos/MicrosoftLogo-300x200.webp', alt: 'Microsoft' },
  { src: 'https://static.seattlefoodtruck.com/logos/privateerholdingslogo-300x200.webp', alt: 'Privateer Holdings' },
  { src: 'https://static.seattlefoodtruck.com/logos/Starbucks-300x200.webp', alt: 'Starbucks' },
];

const RESIDENTIAL_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/Greystar.webp', alt: 'Greystar' },
  { src: 'https://static.seattlefoodtruck.com/logos/CBRE.webp', alt: 'CBRE' },
  { src: 'https://static.seattlefoodtruck.com/logos/AVA.webp', alt: 'AVA' },
  { src: 'https://static.seattlefoodtruck.com/logos/AvalonBAy.webp', alt: 'AvalonBay' },
  { src: 'https://static.seattlefoodtruck.com/logos/Equity.webp', alt: 'Equity' },
  { src: 'https://static.seattlefoodtruck.com/logos/Windermere.webp', alt: 'Windermere' },
];

const BREWERY_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/BlackRaven.webp', alt: 'Black Raven' },
  { src: 'https://static.seattlefoodtruck.com/logos/Broadview.webp', alt: 'Broadview' },
  { src: 'https://static.seattlefoodtruck.com/logos/Locus.webp', alt: 'Locus' },
  { src: 'https://static.seattlefoodtruck.com/logos/Rooftop.webp', alt: 'Rooftop' },
  { src: 'https://static.seattlefoodtruck.com/logos/UrbanFamily.webp', alt: 'Urban Family' },
  { src: 'https://static.seattlefoodtruck.com/logos/Figurehead.webp', alt: 'Figurehead' },
];

const COMMUNITY_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/Bumbershoot.webp', alt: 'Bumbershoot' },
  { src: 'https://static.seattlefoodtruck.com/logos/TasteWA.webp', alt: 'Taste WA' },
  { src: 'https://static.seattlefoodtruck.com/logos/Pridefest.webp', alt: 'Pridefest' },
  { src: 'https://static.seattlefoodtruck.com/logos/Sasquatch.webp', alt: 'Sasquatch' },
  { src: 'https://static.seattlefoodtruck.com/logos/QAFarmers.webp', alt: 'Queen Anne Farmers Market' },
];

const PREMIUM_PROMO_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/AmazonLogo-300x200.webp', alt: 'Amazon' },
  { src: 'https://static.seattlefoodtruck.com/logos/Bungie-300x200.webp', alt: 'Bungie' },
  { src: 'https://static.seattlefoodtruck.com/logos/comcastlogo-300x200.webp', alt: 'Comcast' },
  { src: 'https://static.seattlefoodtruck.com/logos/Expedia-300x200.webp', alt: 'Expedia' },
  { src: 'https://static.seattlefoodtruck.com/logos/googlelogo-300x200.webp', alt: 'Google' },
];

const PORTLAND_LOGOS = [
  { src: 'https://static.seattlefoodtruck.com/logos/Adidas.webp', alt: 'Adidas' },
  { src: 'https://static.seattlefoodtruck.com/logos/Airbnb.webp', alt: 'Airbnb' },
  { src: 'https://static.seattlefoodtruck.com/logos/BoeingLogo.webp', alt: 'Boeing' },
  { src: 'https://static.seattlefoodtruck.com/logos/ColumbiaSportsWear.webp', alt: 'Columbia Sportswear' },
  { src: 'https://static.seattlefoodtruck.com/logos/IntelLogo.webp', alt: 'Intel' },
  { src: 'https://static.seattlefoodtruck.com/logos/NikeLogo.webp', alt: 'Nike' },
  { src: 'https://static.seattlefoodtruck.com/logos/USBank.webp', alt: 'US Bank' },
  { src: 'https://static.seattlefoodtruck.com/logos/YahooLogo.webp', alt: 'Yahoo' },
];

function LogoList({ title, residential, breweries, community, premiumPromo, className }) {
  const { city_name } = useContext(ConfigContext);
  const isPortland = city_name === 'Portland';

  let logos = DEFAULT_LOGOS;
  let organizations = 'campuses';

  if (residential) {
    logos = RESIDENTIAL_LOGOS;
    organizations = 'companies';
  } else if (breweries) {
    logos = BREWERY_LOGOS;
    organizations = 'locations';
  } else if (community) {
    logos = COMMUNITY_LOGOS;
    organizations = 'companies';
  } else if (premiumPromo) {
    logos = PREMIUM_PROMO_LOGOS;
  } else if (isPortland) {
    logos = PORTLAND_LOGOS;
    organizations = 'companies';
  }

  const logoList = logos.map((logo, i) => {
    return (
      <div key={'logo' + logo.alt}>
        <img src={logo.src} alt={logo.alt} loading='lazy' />
      </div>
    );
  });

  const displayTitle = title || `Some of the ${organizations} we work with`;

  return (
    <div className={className}>
      { !premiumPromo &&
        <h4 className='u-phosphate u-textCenter'>{displayTitle}</h4>
      }
      <div className={styles.LogoList}>
        {logoList}
      </div>
    </div>
  );
}

export default LogoList;
